module.exports = __webpack_public_path__ + "img/cloud1.f596a4c0.png";